var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-container-class"},[_c('div',{staticClass:"prism-player"},[_c('div',{ref:"playerTemp"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }